import React, { useMemo, useState } from 'react'
import { notification } from 'antd'
import styled from 'styled-components'
import { CommonUtility, VideosService } from 'utility'
import { CustomTable, LoaderBar, UserAvatarWithName } from 'components'
import { GetFlaggedCommentList } from 'hooks'
import { Funnel } from 'phosphor-react'
import { ActionBox } from 'components/ActionBox'

const VideoCardContainer = styled.div`
  display: flex;
  justify-content: flex-start;
  flex-wrap: wrap;
`

// Filter css
const FilterSortContainer = styled.div`
  display: flex;
  margin: 0 0 20px 0;
  justify-content: space-between;
  align-items: center;
  padding: 10px 16px;
`
const SortContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 8px 12px;
  border: 1px solid #ccc;
  border-radius: 8px;
  font-size: 14px;
  font-weight: 500;
`
const StyledSelect = styled.select`
  border: none;
  font-weight: bold;
  background: transparent;
  outline: none;
`
const FilterButton = styled.button`
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 8px 12px;
  border: 1px solid #ccc;
  border-radius: 8px;
  font-size: 14px;
  font-weight: 500;
  background: white;
  cursor: pointer;
  transition: background 0.3s ease;

  &:hover {
    background-color: #f0f0f0;
  }
`

export const FlaggedCommentList = ({ type }) => {
  const { data, filter, pageChanged, total, loading, setData } =
    GetFlaggedCommentList(type)
  const [processing, setProcessing] = useState(false)

  const toggleBlock = async (id, active) => {
    try {
      setProcessing(true)
      await VideosService.toggleBlock(id, active)
      setData(
        data.map(item => {
          if (item._id === id) {
            return {
              ...item,
              isActive: active,
            }
          }
          return item
        }),
      )
    } catch (error) {
      notification.error({ message: 'Something went wrong' })
    } finally {
      setProcessing(false)
    }
  }
  console.log("🚀 ~ toggleBlock ~ toggleBlock:", toggleBlock)

  const columns = useMemo(
    () => [
      {
        title: 'Name',
        dataIndex: 'name',
        key: 'name',
        render: (_, record) => (
          <UserAvatarWithName id={record?.fid} title={record?.name} url={record.image} />
        ),
      },
      {
        title: 'Email',
        dataIndex: 'email',
        key: 'email',
      },
      {
        title: 'Phone Number',
        dataIndex: 'phone_number',
        key: 'phone_number',
      },

      {
        title: 'Genre',
        dataIndex: 'genre',
        key: 'genre',
      },
      {
        title: 'Birth Date',
        dataIndex: 'birth_date',
        key: 'birth_date',
      },
      {
        title: 'Total Videos',
        dataIndex: 'videos',
        key: 'videos',
        render: value => <span>{CommonUtility.numberFormat(value)}</span>,
      },
      {
        title: 'Followers',
        dataIndex: 'followers',
        key: 'followers',
        render: value => <span>{CommonUtility.numberFormat(value)}</span>,
      },
      {
        title: 'Action',
        dataIndex: 'Action',
        key: 'Action',
        align: 'right',
        width: 100,
        render: (_, record) => (
          <ActionBox
            item={record}
            onBlock={() => console.log(record._id, !record.isBlocked)}
          />
        ),
      },
    ],
    [data],
  )

  return (
    <VideoCardContainer className="row">
      {(loading || processing) && <LoaderBar />}
      <FilterSortContainer>
        <SortContainer>
          <span>Sort by:</span>
          <StyledSelect>
            <option>Name A-Z</option>
            <option>Name Z-A</option>
            <option>Date Newest</option>
            <option>Date Oldest</option>
          </StyledSelect>
        </SortContainer>
        <FilterButton>
          <Funnel size={20} weight="bold" />
          Filters
        </FilterButton>
      </FilterSortContainer>
      <CustomTable
        data={data}
        columns={columns}
        pageChanged={pageChanged}
        page={filter.page}
        loading={loading}
        total={total}
      />
    </VideoCardContainer>
  )
}
